import React from 'react'

type CircularProgressProps = {
  percentage: number
  color: string
  size?: number
  strokeWidth?: number
  showPercentage?: boolean
}

export const CircularProgress = ({
  percentage,
  color,
  size = 32,
  strokeWidth = 4,
  showPercentage = true,
}: CircularProgressProps) => {
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const strokeDashoffset = circumference - (percentage / 100) * circumference

  return (
    <svg width={size} height={size}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="#e2e8f0"
        strokeWidth={strokeWidth}
        style={{ transform: 'rotate(-90deg)', transformOrigin: 'center' }}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
        style={{
          transform: 'rotate(-90deg)',
          transformOrigin: 'center',
          transition: 'stroke-dashoffset 0.3s ease-in-out',
        }}
      />
      {showPercentage && (
        <text
          x="50%"
          y="50%"
          dominantBaseline="central"
          textAnchor="middle"
          fontSize={size * 0.28}
          fontWeight={600}
          fill="#1e293b"
        >
          {percentage}%
        </text>
      )}
    </svg>
  )
}
